import { SELECT_PARCELS, DESELECT_PARCELS, ADD_PROJECT, MOVE_ITEM, ADD_TO_PROJECT } from '../actions/parcels'
import { morph } from '../utils'

const defaultState = {
    items: [],
    nextProjectId: 1
}

export default (state = defaultState, action) => {
    const { type } = action
    const { items, nextProjectId } = state

    switch (type) {
        case SELECT_PARCELS:
            return {
                items: [...items, ...action.parcels.map(parcel => morph(parcel, { type: 'parcel', parent: null }))],
                nextProjectId
            }

        case DESELECT_PARCELS:
            return {
                items: items.filter(
                    item => !(action.apns.includes(item.apn || item.id) || action.apns.includes(item.parent))
                ),
                nextProjectId
            }

        case ADD_PROJECT: {
            const index = items.findIndex(item => item.parent === null && item.apn === action.parcels[0])
            const project = {
                type: 'project',
                label: `Project ${nextProjectId}`,
                id: `project-${nextProjectId}`,
                parent: null
            }

            // Insert the project at the index of the first parcel, and assign the `parent` attr for included parcels
            return {
                items: [
                    ...items.slice(0, index),
                    project,
                    ...items
                        .slice(index)
                        .map(item =>
                            action.parcels.includes(item.apn) && item.parent === null
                                ? morph(item, { parent: project.id })
                                : item
                        )
                ],
                nextProjectId: nextProjectId + 1
            }
        }

        case MOVE_ITEM: {
            const sourceIndex = items.findIndex(item => (item.apn || item.id) === action.item)
            const target = items.find(item => (item.apn || item.id) === action.target)
            let targetIndex = items.findIndex(item => (item.apn || item.id) === action.target)
            if (sourceIndex < targetIndex) {
                targetIndex -= 1
            }
            const filtered = items.filter(item => (item.apn || item.id) !== action.item)
            const sliceAt = targetIndex + (action.anchor === 'before' ? 0 : 1)

            return {
                items: [
                    ...filtered.slice(0, sliceAt),
                    morph(items[sourceIndex], { parent: target.parent }), // Re-parent moved item
                    ...filtered.slice(sliceAt)
                ],
                nextProjectId
            }
        }

        case ADD_TO_PROJECT:
            return {
                items: items.map(item =>
                    item.type === 'parcel' && action.parcel === item.apn
                        ? morph(item, { parent: action.project })
                        : item
                ),
                nextProjectId: nextProjectId + 1
            }

        default:
            return state
    }
}
